import { EventType } from "@omni/types/components/tracking/eventType.enum";

import * as BannerImpressionTracker from "@/services/tracking/trackers/impression/bannerImpression.tracker";
import * as ButtonImpressionTracker from "@/services/tracking/trackers/impression/buttonImpression.tracker";
import * as PageImpressionTracker from "@/services/tracking/trackers/impression/pageImpression.tracker";
import * as SectionImpressionTracker from "@/services/tracking/trackers/impression/sectionImpression.tracker";

import {
    elementHasBeenTracked,
    setElementHasBeenTracked
} from "../trackers/utils";

let impressionElements: Array<HTMLElement> | undefined;
let observer: IntersectionObserver;

const trackGenericImpressions = (): void => {
    impressionElements = Array.from(
        document.querySelectorAll(`[data-tracking-event$="-impression"]`)
    );

    observer = new IntersectionObserver((entries): void => {
        entries.forEach((entry): void => {
            if (entry.intersectionRatio > 0) {
                const target: HTMLElement = entry.target as HTMLElement;
                trackImpressionByType(target);
            }
        });
    });

    impressionElements.forEach((impressionElement) => {
        observer.observe(impressionElement);
    });
};

const trackImpressionByType = (element: HTMLElement) => {
    if (!elementHasBeenTracked(element)) {
        setElementHasBeenTracked(element);

        const eventType =
            (element.dataset.trackingEvent as EventType) || EventType.NONE;

        switch (eventType) {
            case EventType.ButtonImpression:
                ButtonImpressionTracker.trackElement(element);
                break;

            case EventType.PageImpression:
                PageImpressionTracker.track();
                break;

            case EventType.SectionImpression:
                SectionImpressionTracker.trackElement(element);
                break;

            case EventType.BannerImpression:
                BannerImpressionTracker.trackElement(element);
                break;
        }
    }
};

export { trackGenericImpressions };
